const etnias = [
  {
    id: "1",
    etnia: "Mayoritario"
  },
  {
    id: "2",
    etnia: "Afro-descendiente"
  },
  {
    id: "3",
    etnia: "Indigena"
  },
  {
    id: "4",
    etnia: "Gitano"
  },
  {
    id: "5",
    etnia: "Palenquero"
  },
  {
    id: "6",
    etnia: "Raizal Archipielago San Andrés"
  },
  {
    id: "7",
    etnia: "Otro"
  }
]
export default etnias